module.exports = __webpack_public_path__ + "static/media/category.eee2a5c7.svg";